import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '@app/clientHttp/http.service';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { Observable } from 'rxjs';
import { Request } from 'src/app/core/clientHttp/request';

@Injectable({
  providedIn: 'root'
})
export class ApplymentAccessService extends Request implements Resolve<ApplymentAccessService> {

  private response: any = null;

  constructor(
    private http: HttpService,
    private route: Router,
    private applymentModel: ApplymentModel
  ) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {

    let token = localStorage.getItem('token');

    this.url = `get-last-history-applyment/${route.params.hash}/${token}`;
    return this.http.get(this)
      .then((data) => this.response);
  }

  successAction(applymentData) {
    if (applymentData.success) {
      this.redirectsAccordingToType(applymentData);
    }
  }

  errorAction(applymentData) {
    if (!applymentData.success) {
      this.route.navigate([this.applymentModel.getSettings().domainParams], {queryParamsHandling: 'preserve'});
    }
  }

  /**
   * Redireciona conforme o tipo
   * @param applymentData dados da inscrição
   */
  private redirectsAccordingToType(applymentData) {
    switch (applymentData.data.place_type_id) {
      case 1:
        this.redirectToStep(applymentData.data);
        break;
      case 2:
        this.redirectToFeedback(applymentData.data);
        break;
      case 4:
        this.redirectToPage(applymentData.data);
        break;
      case 5:
        this.redirectToPortal();
        break;
      case 6:
          this.redirectPopup(applymentData.data);
          break;
      default:
        this.redirectToSelectiveProcessSelection();
        break;
    }
  }

  private redirectToPage(applymentData) : void {
    if ((window as any).psClosePopUp) {
      (window as any).psClosePopUp();
    }
    this.route.navigate([
      this.applymentModel.getSettings().domainParams + '/processo', applymentData.selective_process_id, 'pagina', applymentData.place_id
    ],
    {
      queryParamsHandling: 'preserve',
      state: { stage_id: applymentData.stage_id }
    });
  }

  private redirectToPortal(): void {
    if ((window as any).psClosePopUp) {
      (window as any).psClosePopUp();
    }
    this.route.navigate([this.applymentModel.getSettings().domainParams + '/portal-inscrito'], {queryParamsHandling: 'preserve'});
  }

  private redirectToStep(applymentData) : void {
    if ((window as any).psClosePopUp) {
      (window as any).psClosePopUp();
    }
    localStorage.setItem('last_place_id', applymentData.place_id);
    localStorage.setItem('last_place_type_id', '1');
    this.route.navigate([this.applymentModel.getSettings().domainParams + '/passo', applymentData.place_id], {queryParamsHandling: 'preserve'});
  }

  private redirectToFeedback(applymentData) : void {
    if ((window as any).psClosePopUp) {
      (window as any).psClosePopUp();
    }
    localStorage.setItem('last_place_id', applymentData.place_id);
    localStorage.setItem('last_place_type_id', '2');
    this.route.navigate([
      this.applymentModel.getSettings().domainParams + '/feedback', applymentData.place_id
    ],
    {
      queryParamsHandling: 'preserve'
    });
  }

  private redirectToSelectiveProcessSelection() {
    this.route.navigate([this.applymentModel.getSettings().domainParams], {queryParamsHandling: 'preserve'});
  }

  private redirectPopup(applymentData) {
    applymentData.completed ? this.redirectToPortal() : this.redirectToSelectiveProcessSelection();
  }
}
